import React, { useState } from 'react';
import { last } from 'lodash';
import { getMetadataItemsToShow } from '../../../../utils/getMetadataItemsToShow';
import { mpShowMoreMetadataViewed } from '../../../../events/mixpanel/mpShowMoreMetadataViewed';
import { bqClickedOnShowMoreGigMetadata } from '../../../../events/bigQuery/clickedOnShowMoreGigMetadata';
import { useGigInfoContext } from '../../../GigInfoContext/GigInfoContext';
import { LabelItem } from './LabelItem';
import { HiddenItemsLabel } from './HiddenItemsLabel';

interface LabelItemsProps {
  label: string;
  items: string[];
}

const useSeeMore = ({ label, items }) => {
  const [seeMore, setSeeMore] = useState(false);
  const numberOfItemsToShow = seeMore ? items.length : getMetadataItemsToShow({ label, items });
  const itemsToShow = items.slice(0, numberOfItemsToShow);
  const hiddenItems = items.slice(numberOfItemsToShow);
  const hasHiddenItems = hiddenItems.length > 0;
  const expandSeeMore = () => setSeeMore(true);

  return {
    itemsToShow,
    hiddenItems,
    hasHiddenItems,
    expandSeeMore,
  };
};

export const LabelItems: React.FC<LabelItemsProps> = ({ label, items }) => {
  const { biEvents } = useGigInfoContext();
  const { itemsToShow, hiddenItems, hasHiddenItems, expandSeeMore } = useSeeMore({ label, items });

  const onSeeMoreClick = () => {
    biEvents.sendMixPanelEvent(mpShowMoreMetadataViewed());
    biEvents.sendRawBigQueryEvent(
      bqClickedOnShowMoreGigMetadata({
        label,
        items,
        hiddenItemsCount: hiddenItems.length,
        enrichmentData: biEvents.getBigQueryEnrichmentData(),
      })
    );
    expandSeeMore();
  };

  return (
    <>
      {itemsToShow.map((item) => (
        <LabelItem key={item} item={item} isLastItem={item === last(itemsToShow)} />
      ))}
      {hasHiddenItems && <HiddenItemsLabel items={hiddenItems} onClick={onSeeMoreClick} />}
    </>
  );
};
